"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const DeviceProvider_1 = require("../DeviceProvider");
const Visible = ({ desktop = false, mobile = false, children }) => {
    const { isDesktop, isMobile } = (0, DeviceProvider_1.useDevice)();
    if ((desktop && isDesktop) || (mobile && isMobile)) {
        return (0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: children });
    }
    return null;
};
exports.default = Visible;
//# sourceMappingURL=index.js.map